import React, { useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import GreenButton from '../../../../ui/GreenButton';
import Swal from "sweetalert2";
import axios from 'axios'

const Wrapper = styled.div`

  width: 700px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 2px #ccc;
  padding: 24px;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;

  label {
    font-weight: bold;
    color: #4f4f4f;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  input {
    border-radius: 6px;
    padding: 0px 10px;
    height: 35px;
    border: 1px solid #ccc;
    background: #f8f8f8;
  }
`;

const Card = styled.div`
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  input, textarea {
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 8px 10px;
  }

  textarea {
    width: 100%;
    min-height: 80px;
    resize: vertical;
    background: #f9f9f9;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 10px;
`;



const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  strong {
    color: #444;
    font-weight: 700;
  }
`;


const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid #eee;
  border-radius: 10px;

  /* sombra nas bordas ao rolar (suporte moderno) */
  /* mask-image: linear-gradient(to right, transparent 0, black 16px, black calc(100% - 16px), transparent 100%); */
`;

const StyledTable = styled.table`
  width: 100%;
           /* garante scroll em telas pequenas */
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  tbody tr {
    transition: background 0.15s ease;
  }
  tbody tr:nth-child(even) {
    background: #fcfcfc;
  }
  tbody tr:hover {
    background: #FFF7F0;       /* laranja bem suave no hover */
  }

  tbody td {
    border-bottom: 1px solid #f0f0f0;
    vertical-align: top;
  }
  tbody tr:last-child td {
    border-bottom: 0;
  }

  /* cantos arredondados do bloco */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição: quebra de linha e largura máxima */
  td.desc {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px;
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


function toInputLocal(dt = new Date()) {
  // formata para "YYYY-MM-DDTHH:MM" (sem segundos)
  const pad = (n) => String(n).padStart(2, '0');
  const year = dt.getFullYear();
  const month = pad(dt.getMonth() + 1);
  const day = pad(dt.getDate());
  const hour = pad(dt.getHours());
  const min = pad(dt.getMinutes());
  return `${year}-${month}-${day}T${hour}:${min}`;
}

export default function ApontarHorasChamado({ urlApi, verChamadoAtendimento, verChamadoFinalizado, verChamadoCancelado }) {

  const verChamado = verChamadoAtendimento || verChamadoFinalizado || verChamadoCancelado;

  console.log('apontamento', verChamado)

  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');

  const [descricao, setDescricao] = useState('');
  const [inicio, setInicio] = useState(toInputLocal());       // agora
  const [fim, setFim] = useState(toInputLocal());             // agora





  async function salvarPeriodo() {
    try {
      if (!inicio || !fim) {
        toast.warn('Informe início e fim.');
        return;
      }
      if (new Date(fim) <= new Date(inicio)) {
        toast.warn('Fim deve ser maior que o início.');
        return;
      }

      const body = {
        inicio,                 // "YYYY-MM-DDTHH:mm"
        fim,
        descricao: descricao || '',
        cod_funcionario: id,    // <<< padronizado para o back
        id_chamado: verChamado?.ID_CHAMADO // <<< envie o id do chamado
      };

      const resp = await fetch(`${urlApi}central-ti/apontar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (resp.status === 409) {
        const e = await resp.json().catch(() => ({}));
        toast.error(e.error || 'Período se sobrepõe a outro já registrado.');
        return;
      }

      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        throw new Error(e.error || 'Falha ao salvar.');
      }

      setDescricao('');
      setInicio(toInputLocal(new Date()));
      setFim(toInputLocal(new Date()));


      toast.success('Apontamento registrado.');
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Erro ao salvar período.');
    }
  }





  const [apontamentos, setApontamentos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [mostrarApontamentos, setMostrarApontamentos] = useState(false);

  const idChamado = verChamado?.ID_CHAMADO;

  const carregarApontamentosDoChamado = useCallback(async (id) => {
    if (!id) return;

    setCarregando(true);
    try {
      const resp = await axios.get(
        `${urlApi}central-ti/ver-apontamentos/${encodeURIComponent(id)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = resp?.data ?? [];
      setApontamentos(Array.isArray(data) ? data : []);
    } catch (err) {
      const msg = err?.response?.data?.error || err.message || 'Erro ao carregar apontamentos.';
      console.error(err);
      toast.error(msg);
    } finally {
      setCarregando(false);
    }
  }, [token, urlApi]);







  //---------------------------------------FUNÇÂO DELETAR APONTAMENTO---------------------------------------------------//

  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Essa ação irá apagar o apontamento, deseja confirma?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDeletarApontamento = async (it) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}central-ti/deletar-apontamento/${it.ID_APONTAMENTO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Apontamento deletado com sucesso.");


    } catch (error) {

      toast.error(error);


    }


  };




  return (
    <Wrapper>
      <h2 style={{ color: '#575757', marginTop: 0 }}>Apontar Horas de Trabalho</h2>

      <Header>
        <label>
          Nº Chamado
          <input type="text" value={verChamado?.ID_CHAMADO || ''} disabled />
        </label>
        <label>
          Solicitante
          <input type="text" value={`${verChamado?.COD_FUNCIONARIO_SOLICITANTE} - ${verChamado?.Primeiro_Nome_Solicitante}` || ''} disabled />
        </label>
        <label>
          Situação
          <input type="text" value={verChamado?.DESC_SITUACAO || ''} disabled />
        </label>
      </Header>
      <Header>
        <label>
          Aberto
          <input type="text" value={verChamado?.DATA_FORMATADA || ''} disabled />
        </label>
        <label>
          Atendido
          <input type="text" value={`${verChamado?.DATA_FORMATADA2}` || ''} disabled />
        </label>
        <label>
          Finalizado
          <input type="text" value={verChamado?.DATA_FORMATADA3 || ''} disabled />
        </label>
      </Header>

      {/* Quadro tipo textarea para descrição + botão adicionar */}
      <Card>


        <Row style={{ margin: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontWeight: 600, color: '#4f4f4f' }}>Início</label>
            <input
              type="datetime-local"
              value={inicio}
              onChange={(e) => setInicio(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontWeight: 600, color: '#4f4f4f' }}>Fim</label>
            <input
              type="datetime-local"
              value={fim}
              onChange={(e) => setFim(e.target.value)}
            />
          </div>
        </Row>

        <Row>
          <textarea
            placeholder="Descreva o que foi feito neste período (opcional, mas recomendado)…"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
          />
        </Row>

        <Actions>
          <GreenButton onClick={salvarPeriodo}>Salvar Apontamento</GreenButton>

        </Actions>


      </Card>

      {/* Lista de períodos */}

      <Card>
        <HeaderBar>
          <strong style={{ color: '#575757' }}>Períodos registrados</strong>

          <div style={{ display: 'flex', gap: 8 }}>
            {!mostrarApontamentos ? (
              <GreenButton
                onClick={async () => {
                  if (!idChamado) { toast.warn('Chamado não identificado.'); return; }
                  await carregarApontamentosDoChamado(idChamado);
                  setMostrarApontamentos(true);
                }}
                disabled={!idChamado || carregando}
              >
                {carregando ? 'Carregando…' : 'Ver apontamentos'}
              </GreenButton>
            ) : (
              <>
                <GreenButton
                  onClick={async () => {
                    if (!idChamado) return;
                    await carregarApontamentosDoChamado(idChamado); // recarrega on demand
                  }}
                  disabled={carregando}
                >
                  {carregando ? 'Recarregando…' : 'Recarregar'}
                </GreenButton>

                <button
                  type="button"
                  onClick={() => setMostrarApontamentos(false)}
                  style={{
                    border: '1px solid #ddd',
                    background: '#fff',
                    color: '#555',
                    fontWeight: 600,
                    borderRadius: 8,
                    padding: '6px 10px',
                    cursor: 'pointer'
                  }}
                  disabled={carregando}
                  title="Ocultar lista"
                >
                  Ocultar
                </button>
              </>
            )}
          </div>
        </HeaderBar>


        {mostrarApontamentos && (
          <TableScroll>
            <StyledTable>
              <thead>
                <tr>
                  <th>Início</th>
                  <th>Fim</th>
                  <th>Usuário</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {carregando && (
                  <tr>
                    <td colSpan={4} style={{ color: '#777', padding: '14px' }}>
                      Carregando…
                    </td>
                  </tr>
                )}

                {!carregando && apontamentos.length === 0 && (
                  <tr>
                    <td colSpan={4} style={{ color: '#777', padding: '14px' }}>
                      Nenhum período lançado.
                    </td>
                  </tr>
                )}

                {!carregando && apontamentos.map((it) => (
                  <React.Fragment key={it.ID_APONTAMENTO}>
                    <tr>
                      <td>{it.DATA_INICIO_FORMATADA}</td>
                      <td>{it.DATA_FIM_FORMATADA}</td>
                      <td>{it.COD_FUNCIONARIO} - {it.PRIMEIRO_NOME}</td>
                      <td>
                        <button
                          type="button"
                          onClick={() => handleDeletarApontamento(it)}
                          style={{
                            border: '1px solid #FFB266',
                            background: '#FFF',
                            color: '#FF7A00',
                            fontWeight: 600,
                            borderRadius: 8,
                            padding: '6px 10px',
                            cursor: 'pointer'
                          }}
                          title="Deletar período"
                        >
                          Deletar
                        </button>
                      </td>
                    </tr>

                    {it.DESC_SERVICO && (
                      <tr className="desc-servico-row">
                        <td colSpan={4} style={{ padding: '8px 12px', fontSize: 13, color: '#555', borderTop: 'none' }}>
                          <strong>Serviço:</strong> {it.DESC_SERVICO}
                        </td>
                      </tr>
                    )}

                    <tr className="group-gap">
                      <td colSpan={4} />
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </StyledTable>
          </TableScroll>
        )}

      </Card>


    </Wrapper>
  );
}
